<template>

  <div class="myComponent" v-loading="loading">
    <iframe
      width="100%"
      height="100%"
      ref="resouceIframe"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
  /**
   *    create by wjl on 2021.11.16
   *     把之前的答案对比方式，改成了在资源库展示，
   *     维护起来更方便
   *     props中，除了preview，都是必传参数
   *    试题来源于资源库，再回归去资源库。
   */
  import { getStore } from "@/utils/storage";
  export default {
    name: "myComponent",
    props: {
      adminIng:{
        type: Boolean,
        default: false,
      },
      mode: {
        type: String,
        default: 'answer'
      }
    },
    computed:{
      queryData(){
        return sessionStorage.getItem('queryData') && JSON.parse(sessionStorage.getItem('queryData'))
      }
    },
    components: {},
    data() {
      return {
        questionId : sessionStorage.getItem("questionId"),
        raceRoles: sessionStorage.getItem('successStationCode'),
        playerInfo: {},
        resultVal: {},
        loading: true,
        resouceIframe: '',  // 引入资源库
      }
    },
    created() {
      let isSaiWu = sessionStorage.getItem('isSaiWu')
      if(isSaiWu == 'SaiWu') {
        this.playerInfo = JSON.parse(sessionStorage.getItem('playerInfoCopySaiwu')) // 赛务 - 点击查看时传递
        this.resultVal = JSON.parse(localStorage.getItem('plsnDataItem')) // 赛务 - 更改获取的本地数据
      } else {
        this.playerInfo = JSON.parse(getStore("playerInfo"));
        this.resultVal = JSON.parse(getStore("resultVal"));
      }
      this.openResourceIframe('');
    },
    mounted() {

      // console.log('--log--', process.env.VUE_APP_PROJECT_NAME)
      // let that = this;
      // window.addEventListener("message", (message) => {
      //   // 获取从资源库传来的评分内容
      //   if (message.data && message.data.form === 'resource') {
      //     that.$emit('taskSubmit', message.data.bool)
      //   }
      // }, false);
    },
    watch:{
      mode(mode){
        if(mode === 'answer'){
          this.openResourceIframe("")
        }else{
          this.openResourceIframe("&tabName=ds", 'score_result')
        }
      }
    },
    methods: {
      // refresh() {
      //   // 初始化iframe。时间戳是唯一标识
      //   let iframe = this.$refs.resouceIframe;
      //   if (iframe && iframe.contentWindow) {
      //     let iframeWin = iframe.contentWindow;
      //     iframeWin.postMessage({refresh: true}, process.env.VUE_APP_RESOURSE_URL);
      //   }
      // },
      openResourceIframe(tabName) {
        this.resouceIframe = ''
        this.loading = true
        this.$nextTick(()=> {
          setTimeout(()=>{
            let matchPattern = this.resultVal.pattern === 2 ? 1 : this.resultVal.pattern
            let {planId, matchPlanId, playerId, mainVersion, subVersion} = this.playerInfo
            let teamId = matchPattern == 0 ? `${this.playerInfo.teamId}${mainVersion}${subVersion}` : `${parseInt((planId || matchPlanId).toString().substr(-4))}${playerId}${mainVersion}${subVersion}`
            // process.env.VUE_APP_RESOURSE_URL +
            let resoures = window.RESOURSE_URL || process.env.VUE_APP_RESOURSE_URL
            // let resoures = 'https://eduresourcesx.cailian.net'
            let queryParams = `&professionId=${this.queryData.professionId}`
            let lang = sessionStorage.getItem('lang')
            lang = lang === 'en_US' ? 'en' : 'cn'
            if (tabName.indexOf('ds') !== -1) {
              console.log(`${resoures}/#/score_result?tabName=jncp&examType=6&raceRoles=${(this.adminIng ? this.raceRoles : '')}&paperCode=${this.playerInfo.paperCode}&id=${this.questionId}&matchPlanId=${(planId || matchPlanId)}&matchPattern=${matchPattern}&matchTeamId=${teamId}&matchPlayerId=${playerId}&subVersionId=${mainVersion}${subVersion}&timestamp=${+new Date()}${queryParams}&language=${lang}`)
              this.$refs.resouceIframe.contentWindow.location.replace(`${resoures}/#/score_result?tabName=jncp&examType=6&raceRoles=${(this.adminIng ? this.raceRoles : '')}&paperCode=${this.playerInfo.paperCode}&id=${this.questionId}&matchPlanId=${(planId || matchPlanId)}&matchPattern=${matchPattern}&matchTeamId=${teamId}&matchPlayerId=${playerId}&subVersionId=${mainVersion}${subVersion}&timestamp=${+new Date()}${queryParams}&language=${lang}`);
            } else {
              console.log(`${resoures}/#/?tabName=ds&type=comparative_score&examType=6&token=${sessionStorage.getItem('token')}&raceRoles=${(this.adminIng ? this.raceRoles : '')}&paperCode=${this.playerInfo.paperCode}&id=${this.questionId}&matchPlanId=${(planId || matchPlanId)}&matchPattern=${matchPattern}&teamId=${teamId}&matchPlayerId=${playerId}&subVersionId=${subVersion}&timestamp=${+new Date()}${queryParams}&language=${lang}`)
              this.$refs.resouceIframe.contentWindow.location.replace(`${resoures}/#/?tabName=ds&type=comparative_score&examType=6&token=${sessionStorage.getItem('token')}&raceRoles=${(this.adminIng ? this.raceRoles : '')}&paperCode=${this.playerInfo.paperCode}&id=${this.questionId}&matchPlanId=${(planId || matchPlanId)}&matchPattern=${matchPattern}&teamId=${teamId}&matchPlayerId=${playerId}&subVersionId=${subVersion}&timestamp=${+new Date()}${queryParams}&language=${lang}`);
            }
            setTimeout(()=>{
              this.loading = false
            },)
          },400)

        })
      },
    }

  }
</script>

<style scoped lang="scss">
  .myComponent {
    width: 100%;
    height: 100%;
  }
</style>
